import type { TranslationDict } from '../en';

const it: TranslationDict = {
  'header.buy': 'Compra',
  'header.sell': 'Vendi',
  'spend.label': 'Spendi',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Ricevi',
  'payment.label': 'Metodo di pagamento',
  'payment.select': 'Seleziona',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Nessun metodo di pagamento per questa coppia',
  'wallet.label': 'Indirizzo del portafoglio di ricezione',
  'wallet.placeholderBuy': 'Inserisci il tuo indirizzo di ricezione',
  'wallet.placeholderSell': 'Inserisci il tuo indirizzo di invio',
  'wallet.validating': 'Validazione indirizzo...',
  'wallet.invalid': 'Inserisci un indirizzo valido',
  'wallet.invalidServer': 'Indirizzo del portafoglio non valido',
  'cta.buy': 'Compra {crypto}',
  'cta.sell': 'Vendi {crypto}',
  'cta.gettingPrice': 'Ricerca del miglior prezzo...',
  'cta.processing': 'Elaborazione...',
  'footer.poweredBy': 'Offerto da ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Dettaglio del tasso',
  'rate.close': 'Chiudi',
  'rate.updatesIn': 'Il tasso si aggiorna tra 00:{seconds}',
  'rate.noQuote': 'Nessun preventivo disponibile',
  'rate.exchangeRate': 'Tasso di cambio',
  'rate.processingFee': 'Commissione di elaborazione',
  'rate.networkFee': 'Commissione di rete',
  'rate.provider': 'Fornitore',
  'toast.orderCreated': 'Ordine creato',
  'toast.redirecting': 'Reindirizzamento al checkout...',
  'toast.orderFailed': 'Ordine fallito',
  'toast.couldNotCreate': 'Impossibile creare l\'ordine',
  'toast.quoteError': 'Errore di preventivo',
  'toast.noProviders': 'Nessun fornitore',
  'toast.somethingWrong': 'Qualcosa è andato storto',
  'error.amountZero': 'L\'importo deve essere maggiore di 0',
  'error.minAmountFiat': 'L\'importo minimo è {min} {currency}',
  'error.minAmountCrypto': 'L\'importo minimo è {min} {currency}',
  'error.noProviders': 'Nessun fornitore disponibile per questa combinazione',
  'error.currencyUnavailableBuy': 'Questa valuta non è disponibile per gli acquisti',
  'error.currencyUnavailableSell': 'Questa valuta non è disponibile per le vendite',
  'parity.info': 'Ti verrà addebitato {receiveAmount} {crypto}, il resto fino a {spendAmount} {fiat} verrà accreditato sul tuo account {partner}',
  'redirect.secureBadge': 'Pagamento sicuro',
  'redirect.title': 'Continua il pagamento',
  'redirect.description': 'Verrai reindirizzato a {gateway} per completare il pagamento.',
  'redirect.countdown': 'Reindirizzamento tra {seconds}...',
  'redirect.openTab': 'Apri ACH in una nuova scheda',
  'redirect.cancel': 'Annulla',
  'checkout.noOrder': 'Nessun ordine trovato',
  'checkout.goBack': 'Torna indietro',
  'checkout.expired': 'Checkout scaduto',
  'checkout.expiredDesc': 'La sessione è scaduta. Riprova.',
  'checkout.startOver': 'Ricomincia',
  'checkout.cancel': 'Annulla',
  'checkout.loading': 'Caricamento checkout...',
  'checkout.iframeTitle': 'Checkout del fornitore',
  'checkout.widgetTitle': 'Checkout di pagamento',
  'checkout.unknownMethod': 'Metodo di checkout sconosciuto',
  'processing.default': 'Elaborazione del tuo ordine...',
  'processing.pending': 'In attesa di conferma del pagamento...',
  'processing.active': 'Elaborazione della tua transazione...',
  'processing.generic': 'Elaborazione...',
  'processing.checkingStatus': 'Verifica dello stato...',
  'processing.orderId': 'ID ordine',
  'processing.provider': 'Fornitore',
  'processing.amount': 'Importo',
  'processing.receiving': 'In ricezione',
  'processing.network': 'Rete',
  'processing.toAddress': 'Indirizzo destinazione',
  'processing.usuallyMinutes': 'Di solito ci vogliono pochi minuti.',
  'processing.safeToClose': 'Puoi chiudere questa pagina in sicurezza - ti invieremo un\'email al completamento.',
  'complete.buyTitle': 'Acquisto completato!',
  'complete.sellTitle': 'Vendita completata!',
  'complete.buyDesc': 'I tuoi {crypto} sono stati inviati al tuo portafoglio.',
  'complete.sellDesc': 'Il tuo pagamento in {fiat} è in fase di elaborazione.',
  'complete.amountBuy': 'Importo ricevuto',
  'complete.amountSell': 'Importo venduto',
  'complete.paidBuy': 'Importo pagato',
  'complete.paidSell': 'Importo del pagamento',
  'complete.network': 'Rete',
  'complete.wallet': 'Portafoglio',
  'complete.transaction': 'Transazione',
  'complete.provider': 'Fornitore',
  'complete.orderId': 'ID ordine',
  'complete.completed': 'Completato',
  'complete.viewExplorer': 'Visualizza su Explorer',
  'complete.done': 'Fatto',
  'errorStep.failed': 'Pagamento fallito',
  'errorStep.cancelled': 'Ordine annullato',
  'errorStep.expired': 'Ordine scaduto',
  'errorStep.refunded': 'Ordine rimborsato',
  'errorStep.unknown': 'Qualcosa è andato storto',
  'errorStep.failedBuy': 'Il tuo pagamento non è stato elaborato. Riprova o utilizza un altro metodo di pagamento.',
  'errorStep.failedSell': 'La tua vendita non è stata elaborata. Riprova.',
  'errorStep.cancelledBuy': 'Il tuo ordine è stato annullato. Nessun pagamento è stato elaborato.',
  'errorStep.cancelledSell': 'La tua vendita è stata annullata. Nessuna criptovaluta è stata trasferita.',
  'errorStep.expiredBuy': 'Il tuo ordine è scaduto. Avvia un nuovo acquisto.',
  'errorStep.expiredSell': 'Il tuo ordine è scaduto. Avvia una nuova vendita.',
  'errorStep.refundedBuy': 'Il tuo pagamento è stato rimborsato. I fondi appariranno sul tuo conto entro 5-10 giorni lavorativi.',
  'errorStep.refundedSell': 'Le tue criptovalute sono state restituite. I fondi appariranno nel tuo portafoglio a breve.',
  'errorStep.genericDesc': 'Si è verificato un errore imprevisto. Riprova.',
  'errorStep.orderId': 'ID ordine',
  'errorStep.tryAgain': 'Riprova',
  'errorStep.startOver': 'Ricomincia',
  'errorStep.return': 'Torna',
  'errorStep.needHelp': 'Hai bisogno di aiuto? Contatta ',
  'errorStep.reference': 'Riferimento: {orderId}',
  'confirm.buyTitle': 'Conferma acquisto',
  'confirm.sellTitle': 'Conferma vendita',
  'confirm.loading': 'Caricamento...',
  'confirm.provider': 'Fornitore',
  'confirm.youPay': 'Paghi',
  'confirm.youSell': 'Vendi',
  'confirm.youReceive': 'Ricevi',
  'confirm.wallet': 'Portafoglio',
  'confirm.network': 'Rete',
  'confirm.refundAddress': 'Indirizzo di rimborso',
  'confirm.parityNote': 'L\'importo addebitato dal fornitore potrebbe differire. Il resto fino a {amount} {crypto} verrà accreditato sul tuo account {partner}.',
  'confirm.processing': 'Elaborazione...',
  'confirm.confirmPay': 'Conferma e paga',
  'confirm.confirmSell': 'Conferma e vendi',
  'confirm.payout': 'Pagamento in {currency}',
  'modal.selectFiat': 'Seleziona valuta fiat',
  'modal.selectCrypto': 'Seleziona criptovaluta',
  'modal.choosePayment': 'Scegli metodo di pagamento',
  'modal.selectCountry': 'Seleziona il tuo paese',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Popolari',
  'modal.recommended': 'Consigliato',
  'modal.noCurrencies': 'Nessuna valuta trovata',
  'modal.noPaymentMethods': 'Nessun metodo di pagamento trovato',
  'modal.noCountries': 'Nessun paese trovato',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Posizione',
  'settings.darkMode': 'Modalità scura',
  'settings.privacy': 'Informativa sulla privacy',
  'settings.terms': 'Termini di utilizzo',
  'settings.language': 'Lingua',
  // ─── Additional ───
  'modal.chooseRamp': 'Scegli Ramp',
  'modal.bestPrice': 'Miglior prezzo',
  'modal.noQuotes': 'Nessun preventivo disponibile per questa richiesta',
  'modal.noProvidersFound': 'Nessun fornitore trovato',
  'payment.unavailableFor': 'Nessun metodo di pagamento disponibile per {currency}',
  'skeleton.poweredBy': 'Offerto da NowRamp',
  'error.createOrderFailed': 'Creazione ordine non riuscita',
  'errorStep.returnToMerchant': 'Torna al commerciante',
  'confirm.cryptoOnNetwork': '{crypto} su {network}',
  'payment.name.card': 'Carta',
  'payment.name.bankTransfer': 'Bonifico bancario',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default it;
